import { render, staticRenderFns } from "./cover1.vue?vue&type=template&id=077943d4&scoped=true&"
import script from "./cover1.vue?vue&type=script&lang=js&"
export * from "./cover1.vue?vue&type=script&lang=js&"
import style0 from "./cover1.vue?vue&type=style&index=0&id=077943d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077943d4",
  null
  
)

export default component.exports